import { useMemo } from "react";

export default function QRCode({ data, size = 200 }) {
  const grid = useMemo(() => {
    const moduleCount = 25;

    let seed = 0;
    for (let i = 0; i < data.length; i++) {
      seed = ((seed << 5) - seed) + data.charCodeAt(i);
      seed |= 0;
    }
    seed = Math.abs(seed) || 1;
    const rand = () => {
      seed = (seed * 16807 + 0) % 2147483647;
      return (seed - 1) / 2147483646;
    };

    const g = [];
    for (let r = 0; r < moduleCount; r++) {
      g[r] = [];
      for (let c = 0; c < moduleCount; c++) {
        g[r][c] = rand() > 0.5;
      }
    }

    // Finder patterns
    const drawFinder = (startR, startC) => {
      for (let r = 0; r < 7; r++) {
        for (let c = 0; c < 7; c++) {
          const isOuter = r === 0 || r === 6 || c === 0 || c === 6;
          const isInner = r >= 2 && r <= 4 && c >= 2 && c <= 4;
          g[startR + r][startC + c] = isOuter || isInner;
        }
      }
    };
    drawFinder(0, 0);
    drawFinder(0, moduleCount - 7);
    drawFinder(moduleCount - 7, 0);

    return g;
  }, [data]);

  const moduleCount = grid.length;
  const moduleSize = size / moduleCount;

  return (
    <div
      style={{ width: size, height: size, display: "grid", gridTemplateColumns: `repeat(${moduleCount}, ${moduleSize}px)` }}
      className="rounded-lg overflow-hidden"
    >
      {grid.flatMap((row, r) =>
        row.map((filled, c) => (
          <div
            key={`${r}-${c}`}
            style={{ width: moduleSize, height: moduleSize, backgroundColor: filled ? "#1a1a2e" : "#ffffff" }}
          />
        ))
      )}
    </div>
  );
}